import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import TableComponent from "../common/TableComponent";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
// import { InAppPurchase } from "../../schema";
import { getAppPurchase, getPlanByUser } from "../../api";
import { Link } from "react-router-dom";

const InApp = () => {
  const { token } = useSelector((state) => state.profileReducer);
  const [allUserData, setAllUserData] = useState([]);
  const [allFilterData, setAllFilterData] = useState([]);
  const [userPlans, setUserPlans] = useState([]);

  const [showview, setShowview] = useState(false);
  // let pageCount = Math.ceil(tabRequests?.length / itemsPerPage);

  const handleCloseview = () => setShowview(false);
  const handleShowview = (userId) => {
    getPlanByUser(userId, token)
      .then((res) => {
        res?.data?.data.map((ele) => {
          switch (ele.hallOfStatus) {
            case 1:
              ele.hallOfStatusStr = "Excellence - ($10)";
              break;
            case 2:
              ele.hallOfStatusStr = "Silver - ($25)";
              break;
            case 3:
              ele.hallOfStatusStr = "Gold - ($50)";
              break;
            case 4:
              ele.hallOfStatusStr = "Founder - ($5)";
              break;
            default:
              ele.hallOfStatusStr = "Standard - ($0)";
              break;
          }
          return true;
        });
        setUserPlans(res?.data?.data);
        setShowview(true);
      })
      .catch((err) => {});
  };

  // const getUserPlans = (array) => {
  //   if (array && array.length !== 0) {
  //     let userPlans = array?.map((e) => e);
  //     return userPlans?.toString();
  //   }
  //   return "-";
  // };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const [isLoading, setIsLoading] = useState(false);

  const toast = useRef(null);

  const hoftypeobj = {
    1: "Excellence - ($10)",
    2: "Silver - ($25)",
    3: "Gold - ($50)",
    4: "Founder - ($5)",
    5: "Standard - ($0)",
  };

  const tableColumnTitles = [
    {
      name: "Full Name",
      field: "Full Name",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Plan/ProductId",
      field: "Plan/ProductId",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Purchase Date",
      field: "Purchase Date",
      isSortFilter: false,
      isAction: false,
    },
    {
      name: "Expiry Date",
      field: "Expiry Date",
      isSortFilter: false,
      isAction: false,
    },
    {
      name: "User Role",
      field: "User Role",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Hof Type",
      field: "Hof Type",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Courtesy",
      field: "Courtesy",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Status",
      field: "Status",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Action",
      isSortFilter: false,
      isAction: true,
    },
  ];

  // getall api
  const getUserDataFromAPI = async () => {
    setIsLoading(true);
    getAppPurchase(token)
      .then((res) => {
        setIsLoading(false);
        res?.data?.data.map((ele) => {
          switch (ele.hallOfStatus) {
            case 1:
              ele.hallOfStatusStr = "Excellence - ($10)";
              break;
            case 2:
              ele.hallOfStatusStr = "Silver - ($25)";
              break;
            case 3:
              ele.hallOfStatusStr = "Gold - ($50)";
              break;
            case 4:
              ele.hallOfStatusStr = "Founder - ($5)";
              break;
            default:
              ele.hallOfStatusStr = "Standard - ($0)";
              break;
          }
          return true;
        });
        setAllUserData(res?.data?.data);
        setAllFilterData(res?.data?.data);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  // Filtering

  const updateResponseData = (searchData) => {
    searchData.map((ele) => {
      if (ele.searchField !== "") {
        if (ele?.searchValue !== "") {
          switch (ele.searchField) {
            case "Full Name":
              const dataUser = allFilterData.filter((item) => {
                const regx = new RegExp(`${ele.searchValue.toLowerCase()}`);
                const fullName =
                  item?.user?.first_name.trim().toLowerCase() +
                  " " +
                  item?.user?.last_name.trim().toLowerCase();
                return regx.test(fullName);
              });
              setAllUserData(dataUser);
              break;
            case "Plan/ProductId":
              const dataPlan = allFilterData.filter((item) =>
                item?.productId
                  ?.toLowerCase()
                  ?.includes(ele.searchValue.toLowerCase())
              );
              setAllUserData(dataPlan);
              break;
            case "User Role":
              const dataUserType = allFilterData.filter((item) => {
                const uname = ele.searchValue.toLowerCase();
                const aname = ele.searchValue.toLowerCase();
                const ambname = ele.searchValue.toLowerCase();
                const startsWithU = uname.startsWith("u");
                const startsWithAdm = aname.startsWith("a");
                const startWithAmb = ambname.startsWith("am");

                if (startsWithU) {
                  return item?.user?.role === "User"; // Filter for gender 1 if the name starts with 'M' or 'm'
                } else if (startsWithAdm) {
                  return item?.user?.role === "Admin"; // Filter for gender 2 if the name starts with f'
                } else if (startWithAmb) {
                  return item?.user?.role === "Ambassador"; // Filter for gender 3 non-binary
                } else {
                  return item?.user?.role;
                }
              });
              setAllUserData(dataUserType);
              break;
            case "Hof Type":
              const datahoftype = allFilterData.filter((item) => {
                const tempArr = [];
                Object.entries(hoftypeobj).forEach((entry) => {
                  const regx = new RegExp(`${ele.searchValue.toLowerCase()}`);
                  const [key, value] = entry;
                  const found = regx.test(value.toLowerCase());
                  if (found) {
                    tempArr.push(+key);
                  }
                });
                return tempArr.includes(item.hallOfStatus);
              });
              setAllUserData(datahoftype);
              break;
            case "Status":
              const dataStatus = allFilterData.filter((item) => {
                const regx = new RegExp(`${ele.searchValue.toLowerCase()}`);
                const foundActive = regx.test("active");
                const foundExpired = regx.test("expired");
                return (
                  (foundActive && item?.user.premium) ||
                  (foundExpired && !item?.user.premium)
                );
              });
              setAllUserData(dataStatus);
              break;

            default:
              break;
          }
        } else {
          setAllUserData(allFilterData);
        }
      }
      return "";
    });
  };

  useEffect(() => {
    async function getAllAPI() {
      await getUserDataFromAPI();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // particular array data
  // const getSpecialties = (array) => {
  //   if (array && array.length !== 0) {
  //     let speciality = array?.map((e) => e.name_en);
  //     return speciality?.toString();
  //   }
  //   return "-";
  // };

  const adminTableRequests = (ele, index) => {
    return (
      <>
        <tr key={index} className="table-light">
          <td>
            <div className="image d-flex align-items-center">
              <img
                alt="Thumbnail"
                className="img-circle elevation-2 profile-img"
                src={
                  ele?.user?.profile_pic
                    ? ele?.user?.profile_pic
                    : require("../../assets/defaultImg.png")
                }
              />
              <h6 className="mb-0 ms-2">
                {ele?.user?.first_name ? ele?.user?.first_name : " - "}{" "}
                {ele?.user?.last_name ? ele?.user?.last_name : "-"}
              </h6>
            </div>
          </td>
          <td>{ele?.productId ? ele?.productId : "-"}</td>
          <td>{formatDate(ele?.purchase_date ? ele?.purchase_date : " - ")}</td>
          <td>{formatDate(ele?.expires_date ? ele?.expires_date : " - ")}</td>
          <td> {ele?.user?.role ? ele?.user?.role : "-"}</td>
          <td> {ele?.hallOfStatusStr ? ele?.hallOfStatusStr : "-"}</td>
          <td> {ele?.user?.courtesy ? `$${ele.user.courtesy}` : "-"}</td>
          <td>{ele?.user?.premium ? "Active" : "Expired"}</td>
          <td>
            {" "}
            <Link
              aria-expanded="false"
              data-toggle="collapse"
              className="action-link "
              onClick={() => handleShowview(ele.userId)}
            >
              <svg
                width="20"
                height="14"
                viewBox="0 0 20 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="me-2"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.3377 6.7875C17.8352 2.90106 14.164 0.28158 10.0002 0.125C5.83641 0.28158 2.1652 2.90106 0.662722 6.7875C0.613077 6.92482 0.613077 7.07518 0.662722 7.2125C2.1652 11.0989 5.83641 13.7184 10.0002 13.875C14.164 13.7184 17.8352 11.0989 19.3377 7.2125C19.3874 7.07518 19.3874 6.92482 19.3377 6.7875ZM6.25 7C6.25 4.92893 7.92893 3.25 10 3.25C12.0711 3.25 13.75 4.92893 13.75 7C13.75 9.07107 12.0711 10.75 10 10.75C7.92893 10.75 6.25 9.07107 6.25 7ZM7.5 7C7.5 8.38071 8.61929 9.5 10 9.5C10.663 9.5 11.2989 9.23661 11.7678 8.76777C12.2366 8.29893 12.5 7.66304 12.5 7C12.5 5.61929 11.3807 4.5 10 4.5C8.61929 4.5 7.5 5.61929 7.5 7ZM1.91897 7C3.18772 10.1687 6.68772 12.625 10.0002 12.625C13.3127 12.625 16.8127 10.1687 18.0815 7C16.8127 3.83125 13.3127 1.375 10.0002 1.375C6.68772 1.375 3.18772 3.83125 1.91897 7Z"
                  fill="black"
                />
              </svg>
            </Link>
          </td>
        </tr>
      </>
    );
  };

  return (
    <>
      <Toast ref={toast} />
      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <Modal
        show={showview}
        onHide={handleCloseview}
        centered
        className="user-manamgement-memebership-details"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>User Purchase History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <h5>
              {userPlans[0]?.user?.first_name +
                " " +
                userPlans[0]?.user?.last_name}
            </h5>
            <hr />
          </div>

          <div className="main-membership-data">
            <table className="table table-striped table-bordered table_custom">
              <thead>
                <tr>
                  <th>Plan/Product ID</th>
                  <th>Purchase Date</th>
                  <th>Expiry Date</th>
                  <th>User Role</th>
                  <th>Hof Type</th>
                  <th>Courtesy</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {userPlans.map((ele) => (
                  <tr key={ele.id}>
                    <td>{ele?.productId || "-"}</td>
                    <td>{formatDate(ele?.purchase_date || " - ")}</td>
                    <td>{formatDate(ele?.expires_date || " - ")}</td>
                    <td>{ele?.user?.role || "-"}</td>
                    <td>{ele?.hallOfStatusStr || "-"}</td>
                    <td>
                      {ele?.user?.courtesy ? `$${ele.user.courtesy}` : "-"}
                    </td>
                    <td>
                      {ele?.status === "purchase" && ele.user.premium
                        ? "Active"
                        : "Expired"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="d-flex align-items-center mt-4"></div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseview}
            className="me-3 yes-btn-cls-add btn btn-secondary"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="content-section">
        <div className="card main-user-card">
          <div className="row m-0">
            <div className="mt-4 p-0 mr-2 d-flex justify-content-between align-items-center mu-less-up-side">
              <div className="title-heading">User Membership Management</div>
              <div className="right_section_action"></div>
            </div>
          </div>
          <TableComponent
            tableColumnTitles={tableColumnTitles}
            tabRequests={allUserData}
            tableRowRequests={adminTableRequests}
            updateResponseData={updateResponseData}
            // updateSortingResponseData={updateSortingResponseData}
          />
        </div>
      </div>
    </>
  );
};

export default InApp;
